<mat-card class="pre-validare-card mb-3" *ngIf="cerere">
    <mat-card-header>
        <mat-card-title><mat-icon>verified_user</mat-icon> Pre-validare</mat-card-title>
    </mat-card-header>
    <mat-card-content>

        <!-- Status banner -->
        <div class="pv-status-banner mb-3" *ngIf="pv">
            <span class="badge" [ngClass]="{
                'bg-warning': pv.pas1_status === 'pending' || pv.pas1_status === 'in_lucru',
                'bg-success': pv.pas1_status === 'aprobat',
                'bg-danger': pv.pas1_status === 'respins'
            }">Pas 1: {{ pv.pas1_status }}</span>
            <span class="badge ms-2" [ngClass]="{
                'bg-secondary': pv.pas2_status === 'pending',
                'bg-info': pv.pas2_status === 'in_lucru',
                'bg-success': pv.pas2_status === 'completat'
            }">Pas 2: {{ pv.pas2_status }}</span>
            <span class="badge ms-2" *ngIf="pv.fisa_status !== 'pending'" [ngClass]="{
                'bg-info': pv.fisa_status === 'generata',
                'bg-primary': pv.fisa_status === 'completata',
                'bg-success': pv.fisa_status === 'semnata'
            }">Fișă: {{ pv.fisa_status }}</span>
            <span class="ms-3 text-muted" *ngIf="pv.responsabil_user_name">Responsabil: <strong>{{
                    pv.responsabil_user_name }}</strong></span>
            <span class="ms-3 text-muted" *ngIf="pv.anaf_user_name">Verificare venituri: <strong>{{ pv.anaf_user_name
                    }}</strong></span>
        </div>

        <!-- ═══ REPARTIZARE ═══ -->
        <div class="pv-section" *ngIf="!pv || !pv.responsabil_user_id">
            <h5><mat-icon>assignment_ind</mat-icon> Repartizare responsabil caz</h5>
            <div class="d-flex align-items-end gap-3">
                <mat-form-field appearance="outline" class="flex-grow-1">
                    <mat-label>Selectează responsabil</mat-label>
                    <input matInput [formControl]="responsabilControl" [matAutocomplete]="autoResp"
                        placeholder="Caută după nume...">
                    <mat-autocomplete #autoResp="matAutocomplete" [displayWith]="displayUser">
                        <mat-option *ngFor="let u of filteredResponsabili$ | async" [value]="u">{{ u.name
                            }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <button mat-raised-button color="primary" (click)="repartizeaza()"
                    [disabled]="!responsabilControl.value?.id" class="pv-action-btn">
                    Repartizează
                </button>
            </div>
        </div>

        <!-- ═══ PAS 1 ═══ -->
        <div class="pv-section"
            *ngIf="pv && pv.responsabil_user_id && (pv.pas1_status === 'pending' || pv.pas1_status === 'in_lucru')">
            <h5><mat-icon>fact_check</mat-icon> Pas 1 — Verificare documentație</h5>
            <p class="text-muted">Verificați documentele depuse și eligibilitatea solicitantului.</p>
            <div class="d-flex gap-2">
                <button mat-raised-button color="primary" (click)="aprobaPas1()"><mat-icon>check</mat-icon> Aprobă
                    documentația</button>
                <button mat-raised-button color="warn" (click)="respingePas1()"><mat-icon>close</mat-icon>
                    Respinge</button>
            </div>
            <div *ngIf="pv.pas1_obs" class="mt-2 text-danger"><strong>Observații:</strong> {{ pv.pas1_obs }}</div>
        </div>

        <div class="pv-section pv-respins" *ngIf="pv?.pas1_status === 'respins'">
            <h5><mat-icon color="warn">block</mat-icon> Pas 1 — Respins</h5>
            <p><strong>Motiv:</strong> {{ pv.pas1_obs }}</p>
        </div>

        <!-- ═══ PAS 2: Verificare venituri ═══ -->
        <div class="pv-section" *ngIf="pv?.pas1_status === 'aprobat'">
            <h5><mat-icon>policy</mat-icon> Pas 2 — Verificare venituri</h5>

            <div *ngIf="!pv.anaf_user_id" class="d-flex align-items-end gap-3 mb-3">
                <mat-form-field appearance="outline" class="flex-grow-1">
                    <mat-label>Selectează verificator venituri</mat-label>
                    <input matInput [formControl]="anafControl" [matAutocomplete]="autoAnaf"
                        placeholder="Caută după nume...">
                    <mat-autocomplete #autoAnaf="matAutocomplete" [displayWith]="displayUser">
                        <mat-option *ngFor="let u of filteredAnaf$ | async" [value]="u">{{ u.name }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <button mat-raised-button color="primary" (click)="alocaAnaf()" [disabled]="!anafControl.value?.id"
                    class="pv-action-btn">
                    <mat-icon>person_add</mat-icon> Alocă verificator venituri
                </button>
            </div>

            <div *ngIf="pv.anaf_user_id">
                <p class="text-muted">Verificator venituri: <strong>{{ pv.anaf_user_name }}</strong></p>

                <div *ngIf="docsAnaf.length > 0" class="docs-list mb-2">
                    <div *ngFor="let doc of docsAnaf" class="doc-item">
                        <mat-icon>description</mat-icon>
                        <span>{{ doc.old_name || doc.name }}</span>
                        <button mat-icon-button matTooltip="Descarcă"
                            (click)="downloadDoc(doc.id)"><mat-icon>download</mat-icon></button>
                        <button mat-icon-button color="warn" matTooltip="Șterge"
                            (click)="confirmDeleteDocAnaf(doc.id)"><mat-icon>delete</mat-icon></button>
                    </div>
                </div>

                <div *ngIf="pv.pas2_status !== 'completat'" class="d-flex gap-2 align-items-center">
                    <button mat-stroked-button (click)="anafFileInput.click()"><mat-icon>upload_file</mat-icon> Upload
                        document venituri</button>
                    <input #anafFileInput type="file" [accept]="uploadAccept" (change)="uploadDocsAnaf($event)" multiple
                        hidden>
                    <button mat-raised-button color="primary" (click)="completeazaPas2()"
                        *ngIf="docsAnaf.length > 0"><mat-icon>check</mat-icon> Marchează completat</button>
                </div>

                <div *ngIf="pv.pas2_status === 'completat'" class="mt-2">
                    <span class="badge bg-success">Verificare venituri completată</span>
                </div>
            </div>
        </div>

        <!-- ═══ ANEXE RESPONSABIL ═══ -->
        <div class="pv-section" *ngIf="pv?.responsabil_user_id">
            <h5><mat-icon>attach_file</mat-icon> Anexe responsabil</h5>

            <div *ngIf="anexeActuale.length > 0" class="docs-list mb-2">
                <div *ngFor="let doc of anexeActuale" class="doc-item">
                    <mat-icon>description</mat-icon>
                    <span>{{ doc.old_name || doc.name }} <small class="text-muted">(v{{ doc.version }})</small></span>
                    <button mat-icon-button matTooltip="Descarcă"
                        (click)="downloadDoc(doc.id)"><mat-icon>download</mat-icon></button>
                    <button mat-icon-button matTooltip="Înlocuiește"
                        (click)="confirmReplaceAnexa(doc.id)"><mat-icon>swap_horiz</mat-icon></button>
                    <button mat-icon-button color="warn" matTooltip="Șterge"
                        (click)="confirmDeleteAnexa(doc.id)"><mat-icon>delete</mat-icon></button>
                </div>
            </div>

            <!-- Hidden file input for replace -->
            <input #replaceFileInput type="file" [accept]="uploadAccept" (change)="onReplaceFileSelected($event)"
                hidden>

            <div *ngIf="anexeIstoric.length > 0" class="mb-2">
                <small class="text-muted">Versiuni anterioare:</small>
                <div *ngFor="let doc of anexeIstoric" class="doc-item doc-old">
                    <mat-icon>history</mat-icon>
                    <span>{{ doc.old_name }} <small>(v{{ doc.version }})</small></span>
                    <button mat-icon-button matTooltip="Descarcă"
                        (click)="downloadDoc(doc.id)"><mat-icon>download</mat-icon></button>
                </div>
            </div>

            <button mat-stroked-button (click)="anexaFileInput.click()"><mat-icon>add</mat-icon> Adaugă anexă</button>
            <input #anexaFileInput type="file" [accept]="uploadAccept" (change)="uploadAnexe($event)" multiple hidden>
        </div>

        <!-- ═══ FIȘĂ VERIFICARE ═══ -->
        <div class="pv-section" *ngIf="pv?.responsabil_user_id">
            <h5><mat-icon>assignment</mat-icon> Fișă verificare</h5>

            <div class="row mb-3">
                <div class="col-md-12 mb-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Concluzii</mat-label>
                        <textarea matInput [(ngModel)]="fisaConcluzii" rows="3"></textarea>
                    </mat-form-field>
                </div>
                <div class="col-md-12 mb-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Propuneri</mat-label>
                        <textarea matInput [(ngModel)]="fisaPropuneri" rows="2"></textarea>
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Componență familie</mat-label>
                        <mat-select [(ngModel)]="fisaFamilieConfirmat">
                            <mat-option [value]="null">Neselectat</mat-option>
                            <mat-option [value]="true">Se confirmă</mat-option>
                            <mat-option [value]="false">Nu se confirmă</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-2" *ngIf="fisaFamilieConfirmat === false">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Observații familie</mat-label>
                        <input matInput [(ngModel)]="fisaFamilieObs">
                    </mat-form-field>
                </div>
            </div>

            <div class="d-flex gap-2 flex-wrap">
                <button mat-raised-button (click)="saveFisaFields()"><mat-icon>save</mat-icon> Salvează câmpuri</button>
                <button mat-raised-button color="accent" (click)="generateFisaWord()"><mat-icon>download</mat-icon>
                    Generează Word</button>
                <button mat-stroked-button (click)="fisaSemnataInput.click()"><mat-icon>upload_file</mat-icon> Upload
                    fișă semnată</button>
                <input #fisaSemnataInput type="file" [accept]="uploadAccept" (change)="uploadFiseSemnate($event)"
                    multiple hidden>
            </div>

            <div *ngIf="docsFisa.length > 0" class="docs-list mt-2">
                <div *ngFor="let doc of docsFisa" class="doc-item">
                    <mat-icon>description</mat-icon>
                    <span>{{ doc.old_name || doc.name }}</span>
                    <small class="text-muted ms-2">{{ doc.uploaded_at | date:'dd.MM.yyyy HH:mm' }}</small>
                    <button mat-icon-button matTooltip="Descarcă"
                        (click)="downloadDoc(doc.id)"><mat-icon>download</mat-icon></button>
                </div>
            </div>
        </div>

    </mat-card-content>
</mat-card>